module.exports = __webpack_public_path__ + "img/admin.13bef004.svg";